import { useMemo } from 'react';
import { useApiScopeRequirementMet } from 'utils/permissions/useApiScopeRequirementMet';

/** Which write calls of an admin collection the current user may make. */
export type WriteScopes = {
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
};

/**
 * Scopes for `POST <collectionPath>`, `PUT <itemPath>` and `DELETE <itemPath>`,
 * so the UI only offers writes the backend would accept.
 */
export const useWriteScopes = (
  collectionPath: string,
  itemPath: string,
): WriteScopes => {
  const apiScopeRequirementMet = useApiScopeRequirementMet();
  const canCreate = apiScopeRequirementMet({
    method: 'POST',
    path: collectionPath,
  });
  const canEdit = apiScopeRequirementMet({ method: 'PUT', path: itemPath });
  const canDelete = apiScopeRequirementMet({
    method: 'DELETE',
    path: itemPath,
  });
  return useMemo(
    () => ({ canCreate, canEdit, canDelete }),
    [canCreate, canEdit, canDelete],
  );
};
